import { jsx as n } from "react/jsx-runtime";
import { cloneElement as p } from "react";
import { VStack as i } from "@chakra-ui/react";
import { useStepsContext as l } from "./useStepsContext.mjs";
const x = ({ children: t, ...r }) => {
  const { childRefs: o } = l();
  return /* @__PURE__ */ n(i, { align: "stretch", spacing: 1, ...r, role: "listbox", "aria-label": "List of steps.", children: t.length > 0 && t.map((s, e) => p(s, {
    stepNumber: e + 1,
    ref: (m) => o.current[e] = m
  })) });
};
export {
  x as StepsList
};
